import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import { DefaultLayout, PublicLayout } from '@/layouts'

Vue.use(Router)
Vue.use(Meta)

const ROUTES = [
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '/',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/DashboardView')
      },
      {
        path: '/apps',
        component: () => import(/* webpackChunkName: "apps" */ '@/views/MyAppsView'),
      },
      {
        path: '/channels',
        component: () => import(/* webpackChunkName: "channels" */ '@/views/ChannelsListView')
      },
      {
        path: '/channels/:id',
        component: () => import(/* webpackChunkName: "channels" */ '@/views/ChannelsEditView')
      },
      {
        path: '/schedules',
        component: () => import(/* webpackChunkName: "schedules" */ '@/views/SchedulesView')
      },
      {
        path: '/screens/groups',
        component: () => import(/* webpackChunkName: "screens" */ '@/views/ScreenGroupsView')
      },
      {
        path: '/screens',
        component: () => import(/* webpackChunkName: "screens" */ '@/views/ScreensView')
      },
      {
        path: '/store/:id',
        component: () => import(/* webpackChunkName: "store" */ '@/views/AppStoreShowView')
      },
      {
        path: '/store',
        component: () => import(/* webpackChunkName: "store" */ '@/views/AppStoreView')
      }
    ]
  },
  {
    path: '/',
    component: PublicLayout,
    children: [
      {
        path: '/404',
        component: () => import(/* webpackChunkName: "errors" */ '@/views/ErrorView'),
        props: { code: 404 },
        meta: {
          isPublic: true
        }
      },
      {
        path: '/500',
        component: () => import(/* webpackChunkName: "errors" */ '@/views/ErrorView'),
        props: { code: 500 },
        meta: {
          isPublic: true
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: ROUTES
})

router.beforeEach((to, from, next) => {
  /*
  if (!to.matched.some(route => route.meta.isPublic)) {
    const loggedIn = localStorage.getItem('user')

    if (!loggedIn) {
      return next('/login')
    }
  }
  */

  setTimeout(() => next(), 10)
})

router.afterEach(() => {

})

export default router
